module.exports = __webpack_public_path__ + "media/Video 1.67cdfadf.mp4";